import styled from 'styled-components';

export const ItemWrapper = styled.div`
    margin-bottom: 16px;
`;

export const QaRequirementsContent = styled.div`
    height: 400px;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    gap: 16px;
`;

export const Editor = styled.div`
    flex: 1;
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    overflow: auto;
`;
